import { IApplicationsListItem } from 'common/actions/integrations/Applications/interfaces'
import { ApplicationBase, ApplicationStatus } from 'shared/api/common/schemas/applications'

const getApplicationItemById = (state: RootState, id: number): IApplicationsListItem => {
  return (
    state.applications.list.items.find((el) => el.app_id === id) ?? { app_id: id, versions: [] }
  )
}

export const getItems = (state: RootState): IApplicationsListItem[] => {
  return state.applications.list.items
}

export const getFetching = (state: RootState): boolean => {
  return state.applications.list.fetching
}

// Versions
export const getDevVersion =
  (id: number) =>
  (state: RootState): ApplicationBase | null => {
    const application = getApplicationItemById(state, id)
    return application.versions.find((el) => el.version === 0) ?? null
  }

const getVersionWithStatuses = (
  state: RootState,
  id: number,
  statuses: ApplicationStatus[],
): ApplicationBase | null => {
  const application = getApplicationItemById(state, id)
  return application.versions.find((el) => el.version !== 0 && statuses.includes(el.status)) ?? null
}

export const getLastVersion =
  (id: number) =>
  (state: RootState): ApplicationBase | null => {
    return getVersionWithStatuses(state, id, [ApplicationStatus.ACTIVE])
  }

export const getReviewVersion =
  (id: number) =>
  (state: RootState): ApplicationBase | null => {
    return getVersionWithStatuses(state, id, [
      ApplicationStatus.REVIEW_IN_PROGRESS,
      ApplicationStatus.REVIEW_WAITING,
      ApplicationStatus.REVIEW_DECLINE,
    ])
  }

// Publish

export const getPublishApplicationId = (state: RootState): number | null => {
  return state.applications.publish.applicationId
}

export const getPublishFetching = (state: RootState): boolean => {
  return state.applications.publish?.fetching || false
}

export const getApplicationToPublish = (state: RootState): ApplicationBase | null => {
  const id = getPublishApplicationId(state)
  return id !== null ? getDevVersion(id)(state) : null
}

// Review report

export const getReviewReportFetching = (state: RootState): boolean => {
  return state.applications.reviewReport.fetching
}

export const getReviewReportApplicationId = (state: RootState): number | null => {
  return state.applications.reviewReport.applicationId
}

export const getReviewReport = (state: RootState): string => {
  return state.applications.reviewReport.report
}
